export default "__VITE_ASSET__S7RKrKlC__"